import { Observable, Subject } from 'rxjs';

/**
 * A bridge for bidirectional communication between two contexts, such as between a ProseMirror NodeView and its surrounding editor.
 * It provides separate channels for sending and receiving messages in both directions.
 */
export class BidiBridge<UpMessageType = any, DownMessageType = any> {
  private readonly upSubject = new Subject<UpMessageType>();
  private readonly downSubject = new Subject<DownMessageType>();

  /** Stream of messages sent to the up channel. */
  readonly up$: Observable<UpMessageType> = this.upSubject.asObservable();

  /** Stream of messages sent to the down channel. */
  readonly down$: Observable<DownMessageType> = this.downSubject.asObservable();

  /**
   * Sends a message to the up channel.
   * @param message The message to send.
   */
  sendUp(message: UpMessageType) {
    this.upSubject.next(message);
  }

  /**
   * Sends a message to the down channel.
   * @param message The message to send.
   */
  sendDown(message: DownMessageType) {
    this.downSubject.next(message);
  }

  /** Complete both channels. */
  complete() {
    this.upSubject.complete();
    this.downSubject.complete();
  }
}
